module.exports = __webpack_public_path__ + "static/media/4-c.9d9cffdc.png";